import React from 'react';
import { Logo } from '../../assets/logo';
import { Button } from '../styles/Hero.styles';
import styled from 'styled-components';

const StyledNavLink = styled.a`
  color: #000 !important;
  cursor: pointer;
  :hover {
    color: #253ec6 !important;
  }
`;

export default function ResidentsNavbar() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="container">
      <nav className="navbar navbar-expand-lg navbar-light">
        <a className="navbar-brand" href="/" style={{ color: '#253EC6' }}>
          <Logo />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="container text-xs-center">
            <ul
              style={{
                display: 'flex',
                flexGrow: 0,
              }}
            ></ul>
            <ul className="nav navbar-nav">
              <li className="nav-item c-nav">
                <StyledNavLink
                  className="nav-link"
                  onClick={() => scrollToSection('plans')}
                >
                  Plans
                </StyledNavLink>
              </li>
              <li className="nav-item c-nav">
                <StyledNavLink
                  className="nav-link"
                  onClick={() => scrollToSection('why-choose-us')}
                >
                  Why choose us
                </StyledNavLink>
              </li>
              <li className="nav-item c-nav">
                <StyledNavLink
                  className="nav-link"
                  onClick={() => scrollToSection('faq')}
                >
                  FAQs
                </StyledNavLink>
              </li>
            </ul>

            <ul className="nav navbar-nav pull-xs-right">
              <li className="nav-item">
                <span
                  className="nav-link"
                  onClick={() => scrollToSection('plans')}
                >
                  <Button
                    style={{ background: '#253EC6' }}
                    // @ts-ignore
                    hoverBackground="#0093ED"
                  >
                    Get Started
                  </Button>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
